<template>
  <b-modal :id="modalId" hide-header centered @shown="show" @ok="confirm" @hidden="hidden">
    <div class="d-block text-center">
      <Icon name="grTrash" width="36" class="mb-3"/>
      <h1 class="modal-title mb-2">{{ $t('modal_remove_digital_item.title') }}</h1>
      <h4 class="modal-subtitle" v-html="$t('modal_remove_digital_item.text')"></h4>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="row w-100 justify-content-center">
        <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
          <b-button variant="danger" block @click="ok()">
            {{ $t('modal_remove_digital_item.action_confirm') }}
          </b-button>
        </div>
        <div class="col-sm-6 order-sm-0">
          <b-button variant="light" block @click="cancel()">{{ $t('modal_remove_digital_item.action_cancel') }}</b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
export default {
  props: ['modalId', 'digitalItemId', 'photoId', 'printItemId'],

  data() {
    return {
      printItemPhotoIdsToRemove: {}
    }
  },

  methods: {
    show() {

    },

    confirm() {
      this.$emit('confirm')
    },

    hidden() {
      this.$emit('hidden')
    }
  }
}
</script>
